import {WEEK} from '@wandb/common/util/time';

export const MOBILE_BREAKPOINT_PX = 500;

export function isWithinLastWeek({timeMS}: {timeMS: number}): boolean {
  return Date.now() - timeMS <= WEEK;
}
